module.exports = __webpack_public_path__ + "static/media/bnr2.823aab29.jpg";